import React from "react";

const HVACA2Z = () => {
  return (
    <div className="min-h-screen bg-black text-white px-4 py-6 md:px-10">

      {/* HEADER */}
      <header className="mb-10">
        <h1 className="text-xl lg:text-2xl font-bold flex items-center gap-3">
          📘 A–Z HVAC Glossary
        </h1>
      </header>

      {/* A */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">A</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>ACH (Air Changes per Hour)</strong> – Number of times the air within a space is replaced in one hour.</li>
          <li><strong>AHU (Air Handling Unit)</strong> – Central unit that conditions and circulates air.</li>
          <li><strong>A2L Refrigerant</strong> – Mildly flammable, low-GWP refrigerant category (e.g., R-32).</li>
          <li><strong>Air Balancing</strong> – Process of adjusting airflow to meet design requirements.</li>
          <li><strong>Ambient Temperature</strong> – Temperature of surrounding air.</li>
          <li><strong>ASHRAE</strong> – American Society of Heating, Refrigerating and Air-Conditioning Engineers.</li>
          <li><strong>Axial Fan</strong> – Fan that moves air parallel to the shaft.</li>
        </ul>
      </section>

      {/* B */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">B</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>BAS</strong> – Building Automation System.</li>
          <li><strong>BMS</strong> – Building Management System.</li>
          <li><strong>BTU</strong> – British Thermal Unit.</li>
          <li><strong>Boiler</strong> – Equipment used to heat water or generate steam.</li>
          <li><strong>Brazing</strong> – Joining metal parts using filler metal at high temperature.</li>
        </ul>
      </section>

      {/* C */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">C</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>CAV</strong> – Constant Air Volume system.</li>
          <li><strong>CFD</strong> – Computational Fluid Dynamics.</li>
          <li><strong>Chiller</strong> – Removes heat from liquid via refrigeration cycle.</li>
          <li><strong>Coil</strong> – Heat exchanger for heating or cooling air.</li>
          <li><strong>Commissioning</strong> – Verification of system performance.</li>
          <li><strong>COP</strong> – Coefficient of Performance.</li>
          <li><strong>Condenser</strong> – Releases heat and condenses refrigerant.</li>
        </ul>
      </section>

      {/* D */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">D</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>DCV</strong> – Demand Controlled Ventilation.</li>
          <li><strong>DX System</strong> – Direct Expansion cooling system.</li>
          <li><strong>Damper</strong> – Regulates airflow.</li>
          <li><strong>Dehumidification</strong> – Removal of moisture from air.</li>
          <li><strong>Digital Twin</strong> – Virtual replica of physical HVAC system.</li>
        </ul>
      </section>

      {/* E */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">E</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>EC Fan</strong> – Energy-efficient electronically commutated fan.</li>
          <li><strong>EER</strong> – Energy Efficiency Ratio.</li>
          <li><strong>ERV</strong> – Energy Recovery Ventilator.</li>
          <li><strong>Evaporator</strong> – Absorbs heat and evaporates refrigerant.</li>
        </ul>
      </section>

      {/* F */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">F</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>FAHU</strong> – Fresh Air Handling Unit.</li>
          <li><strong>Filter</strong> – Removes dust and particles.</li>
          <li><strong>FDD</strong> – Fault Detection & Diagnostics.</li>
          <li><strong>FCU</strong> – Fan Coil Unit.</li>
        </ul>
      </section>

      {/* G */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">G</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>GWP</strong> – Global Warming Potential.</li>
          <li><strong>Geothermal Heat Pump</strong> – Uses earth as heat source/sink.</li>
          <li><strong>Grille</strong> – Air inlet or outlet cover.</li>
        </ul>
      </section>

      {/* H */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">H</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>Heat Load</strong> – Heat to be removed or added.</li>
          <li><strong>Heat Pump</strong> – Provides heating & cooling.</li>
          <li><strong>HEPA Filter</strong> – High efficiency particulate air filter.</li>
          <li><strong>Humidity</strong> – Moisture content of air.</li>
          <li><strong>HRV</strong> – Heat Recovery Ventilator.</li>
        </ul>
      </section>

      {/* I */}
      <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">I</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
          <li><strong>IAQ</strong> – Indoor Air Quality.</li>
          <li><strong>Inverter Technology</strong> – Variable-speed compressor control.</li>
          <li><strong>IoT</strong> – Internet of Things.</li>
          <li><strong>Insulation</strong> – Reduces heat transfer.</li>
        </ul>
      </section>

      {/* J */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">J</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Jacket Loss</strong> – Heat loss through insulated piping or equipment.</li>
        </ul>
    </section>

    {/* K */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">K</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Kigali Amendment</strong> – Global agreement to phase down high-GWP refrigerants.</li>
        </ul>
    </section>

    {/* L */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">L</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Latent Heat</strong> – Heat involved in moisture removal or addition.</li>
            <li><strong>Load Calculation</strong> – Estimation of heating/cooling demand.</li>
            <li><strong>Louver</strong> – Device allowing airflow while blocking rain or sunlight.</li>
        </ul>
    </section>

    {/* M */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">M</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>MAU (Make-Up Air Unit)</strong> – Supplies fresh air to replace exhausted air.</li>
            <li><strong>MEP</strong> – Mechanical, Electrical, Plumbing.</li>
            <li><strong>Micro Lean Six Sigma</strong> – Simplified process improvement framework.</li>
        </ul>
    </section>

    {/* N */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">N</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Net-Zero Building</strong> – Building producing as much energy as it consumes.</li>
            <li><strong>Noise Criteria (NC)</strong> – Measurement of background noise levels.</li>
        </ul>
    </section>

    {/* O */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">O</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>O&M (Operations & Maintenance)</strong> – Activities to run HVAC systems efficiently.</li>
            <li><strong>Occupancy Sensor</strong> – Detects presence for HVAC control.</li>
        </ul>
    </section>

    {/* P */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">P</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>PM2.5 / PM10</strong> – Fine particulate matter affecting air quality.</li>
            <li><strong>PLC (Programmable Logic Controller)</strong> – Industrial control computer.</li>
            <li><strong>Psychrometrics</strong> – Study of air–water vapor properties.</li>
            <li><strong>Poka-Yoke</strong> – Error-proofing method.</li>
        </ul>
    </section>

    {/* Q */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">Q</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Q (Flow Rate)</strong> – Volume of air or water flow per unit time.</li>
            <li><strong>QA/QC</strong> – Quality Assurance / Quality Control.</li>
        </ul>
    </section>

    {/* R */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">R</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Refrigerant</strong> – Working fluid used for heat transfer.</li>
            <li><strong>Retrofit</strong> – Upgrading existing HVAC systems.</li>
            <li><strong>RCA (Root Cause Analysis)</strong> – Systematic problem-solving method.</li>
            <li><strong>Return Air</strong> – Air returning to HVAC system.</li>
        </ul>
    </section>

    {/* S */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">S</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>SEER (Seasonal Energy Efficiency Ratio)</strong> – Seasonal efficiency rating.</li>
            <li><strong>Sensible Heat</strong> – Heat causing temperature change only.</li>
            <li><strong>SCADA</strong> – Supervisory Control and Data Acquisition.</li>
            <li><strong>Split AC</strong> – Air conditioner with indoor and outdoor units.</li>
        </ul>
    </section>

    {/* T */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">T</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>TAB (Testing, Adjusting & Balancing)</strong> – Process to ensure design airflow.</li>
            <li><strong>Thermostat</strong> – Device controlling temperature.</li>
            <li><strong>Tonnage (TR)</strong> – Cooling capacity (1 TR = 12,000 BTU/hr).</li>
        </ul>
    </section>

    {/* U */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">U</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>UVGI</strong> – Ultraviolet Germicidal Irradiation for air disinfection.</li>
            <li><strong>Unoccupied Mode</strong> – Reduced HVAC operation during no occupancy.</li>
        </ul>
    </section>

    {/* V */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">V</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>VAV (Variable Air Volume)</strong> – System varying airflow based on load.</li>
            <li><strong>VFD (Variable Frequency Drive)</strong> – Controls motor speed.</li>
            <li><strong>Ventilation</strong> – Supply of fresh air.</li>
        </ul>
    </section>

    {/* W */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">W</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Water-Cooled Chiller</strong> – Chiller using cooling tower.</li>
            <li><strong>Wet Bulb Temperature</strong> – Temperature measured with moisture effect.</li>
        </ul>
    </section>

    {/* X */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">X</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>X-Factor (Oversizing)</strong> – Extra capacity added beyond calculated load.</li>
        </ul>
    </section>

    {/* Y */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">Y</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Yield Loss</strong> – Energy loss due to inefficiencies.</li>
        </ul>
    </section>

    {/* Z */}
    <section className="mb-8">
        <h2 className="text-lg lg:text-xl text-yellow-200 font-semibold mb-3">Z</h2>
        <ul className="space-y-2 text-sm [&>li]:text-white">
            <li><strong>Zone</strong> – Individually controlled HVAC area.</li>
            <li><strong>Zoning System</strong> – Divides building into multiple control areas.</li>
        </ul>
    </section>


      {/* FOOTER */}
      <footer className="border-t border-gray-800 pt-4">
        <p className="text-xs text-center text-white/80">
          HVAC knowledge is infrastructure.
          <br />
          This A–Z glossary is the backbone of Airon & Think5Whys.
        </p>
        <p className="mt-3 text-sm text-white/80 leading-relaxed">
          This glossary directly powers:
        </p>
        <ul className="mt-3 space-y-1 text-sm [&>li]:text-white">
          <li>📚 Multilingual HVAC Dictionary</li>
          <li>🔊 TTS Learning</li>
          <li>🧠 Concept Linking in Digital Twin</li>
          <li>🧪 Certification Exams</li>
          <li>🧑‍🔧 Technician Onboarding</li>
        </ul>        
      </footer>

    </div>
  );
};

export default HVACA2Z;
